"use client";

import { useQuery } from "@tanstack/react-query";

import { useAuthStore } from "@/modules/auth/stores/auth-store";

import { getTimezones } from "../services/dashboard";

// The list is derived from PHP's timezone database, which changes a handful of
// times a year — so once per session is plenty, and Infinity says exactly that
// rather than pretending some interval is meaningful.
const STALE_TIME = Infinity;

/**
 * Every city the world-clock picker can offer.
 *
 * `enabled` is the point of this hook: 400-odd entries are not worth fetching
 * for the many users who never open the picker, which is also why they aren't in
 * the dashboard catalog. The picker turns this on when it opens, and the query
 * cache keeps it for the rest of the session.
 */
export function useTimezones(enabled: boolean) {
  const companyUuid = useAuthStore((s) => s.companyAccount?.uuid);

  return useQuery({
    queryKey: ["dashboard", "timezones", companyUuid],
    queryFn: getTimezones,
    enabled: enabled && !!companyUuid,
    staleTime: STALE_TIME,
  });
}
